import type { StudyMissionSelectDto, StudySelectDto } from '@@types/api.types';
import type { FC } from 'react';
import { MeiaGatesTile } from './meia-gates-tile.component';
import { MeiaKopTile } from './meia-kop-tile.component';
import { MeiaOverviewMissionsTile } from './meia-overview-missions-tile.component';
import { MeiaPhaseProgressTile } from './meia-phase-progress-tile.component';
import { MeiaStakeholdersTile } from './meia-stakeholders-tile.component';
import { useMeiaStudyPhaseProgress } from './use-meia-study-phase-progress.hook';

type MeiaStudyOverviewProps = {
  currentUserId?: string;
  isMissionsLoading?: boolean;
  missions: StudyMissionSelectDto[];
  study: StudySelectDto;
};

export const MeiaStudyOverview: FC<MeiaStudyOverviewProps> = (props) => {
  const { currentUserId, isMissionsLoading = false, missions, study } = props;

  const { isProgressError, isProgressLoading, isThreadsLoading, missionRows, studyProgressByPhase, threads } =
    useMeiaStudyPhaseProgress({ missions, study });

  return (
    <div className="grid gap-4 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]">
      <div className="flex flex-col gap-4">
        <MeiaKopTile
          canEdit={false}
          study={study}
        />
        <MeiaOverviewMissionsTile
          isLoading={isMissionsLoading || isThreadsLoading}
          missions={missions}
          studyId={study.id}
          threads={threads}
        />
        <MeiaPhaseProgressTile
          isError={isProgressError}
          isLoading={isMissionsLoading || isProgressLoading}
          missionRows={missionRows}
          studyProgressByPhase={studyProgressByPhase}
        />
      </div>
      <div className="flex flex-col gap-4">
        <MeiaGatesTile studyId={study.id} />
        <MeiaStakeholdersTile
          canManageStakeholders={study.canManageStakeholders}
          currentUserId={currentUserId}
          studyId={study.id}
        />
      </div>
    </div>
  );
};
